// utils
import { cviToVehicle } from '@makemydeal/dr-shared-ui-utils/mapper/cviToVehicle';

// types
import type { IVehicle } from '@makemydeal/dr-platform-types';
import type { CommonOrgDealerVehicle } from '@makemydeal/dr-shared-types/vehicleTypes';
import type { CatalogVehicle } from '../types';

export const catalogToVehicle = (
    data: CommonOrgDealerVehicle & { marketingName?: string; ageDays?: number | null }
): CatalogVehicle => {
    return {
        ...(cviToVehicle(data) as IVehicle),
        marketingName: data.marketingName,
        ageDays: data.ageDays
    };
};
